/**
 * What the Marker.io feedback widget must never capture.
 *
 * Kept apart from ``marker.ts`` so screens can mark elements without importing
 * the SDK loader.
 */

/**
 * Marker.io's client-side exclusion class: the element and its children are
 * replaced by a patterned rectangle in screenshots and session replays, before
 * anything leaves the browser (help.marker.io "Sensitive Data Masking").
 * ``mk-mask`` only rewrites text, which would leave a QR code or an input's
 * value visible, so secrets use ``mk-exclude``.
 */
export const MARKER_EXCLUDE_CLASS = 'mk-exclude';

/**
 * Request/response body and header keys Marker's network recording drops.
 * Covers credentials, session and two-step (C11) material on every auth route.
 */
export const MARKER_EXCLUDED_NETWORK_KEYS: readonly string[] = [
  'password',
  'new_password',
  'current_password',
  'token',
  'access_token',
  'refresh_token',
  'trust_token',
  'mfa_trust_token',
  'totp_code',
  'backup_code',
  'code',
  'current_code',
  'secret',
  'otpauth_uri',
  'backup_codes',
  'enrollment_token',
  // OAuth connect: the CSRF state and the provider consent URL that carries it.
  'state',
  'authorization_url',
  // Sign in with Google (XC-GOOGLE-SIGNIN): the round trip's signed flow pass, the pass that ends
  // in a session, and a join's raw invite link.
  'flow',
  'google_pass',
  'invite_token',
  // A signed GCS upload URL is a bearer credential for that object.
  'upload_url',
  'authorization',
  // Header names may be matched case-sensitively.
  'Authorization',
];

/**
 * Domains whose requests Marker's network recording drops entirely. Signed
 * GCS upload URLs are credentials, and the PUT body is a customer document.
 */
export const MARKER_EXCLUDED_NETWORK_DOMAINS: readonly string[] = ['storage.googleapis.com'];
